import {AUTH_VARIABLES} from "@/common/config"
import {tokenOverrides} from "@/common/theme-tokens"

// inline --auth-* custom-property overrides; bind on the element that carries .auth-ambient
// (App-level wiring must ALSO bind this on the ancestor carrying the class — modals are siblings)
export function authTokenOverrides() {
    return tokenOverrides('auth', AUTH_VARIABLES)
}
